module.exports = __webpack_public_path__ + "img/page_paper_file_document_analytics_chart_icon.aae53102.svg";